import React from "react";

function About() {
  return (
    <div className="about">
      <div className="about-container">
        <div className="title" style={{ marginTop: "5rem" }}>
          <h2 className="h2">ABOUT</h2>
        </div>
        <div className="content">
          <p>
            My name is Yashraj Singh, a dedicated and innovative frontend web
            developer with a keen focus on creating seamless and visually
            appealing user experiences. My expertise lies in harnessing the
            power of cutting-edge technologies such as React, Node.js, Express,
            MongoDB and PostgreSQL. I have completed my BTECH in ECE and have
            worked as a software developer for about 10 months in INFOSYS. I'm
            self taught. Passionate about incorporating the latest trends and
            best practices in web development. Continuously enhancing skills
            through ongoing learning and staying updated with industry
            trends.Whether you're a business owner looking to get started on a
            app or web development project with a frontend web developer, a
            developer looking to collaborate on something cool, or just wanting
            to say hi, shoot me a message and let's work together.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
